module.exports = __webpack_public_path__ + "static/stores-list-1d917ddbf72b77cff5cd2650a7cea946.png";